import { combineReducers } from 'redux';
import {
  FETCH_PROVIDERS_STARTED,
  FETCH_PROVIDERS_SUCCESS,
  FETCH_PROVIDERS_FAILED,
} from './providers.types';

const statusReducer = (
  state = { isLoading: false, error: false },
  { type, error }
) => {
  switch (type) {
    case FETCH_PROVIDERS_STARTED:
      return {
        isLoading: true,
        error: false,
      };
    case FETCH_PROVIDERS_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };
    case FETCH_PROVIDERS_FAILED:
      return {
        isLoading: false,
        error,
      };
    default:
      return state;
  }
};

const byIdReducer = (state = {}, { type, providers }) => {
  if (type === FETCH_PROVIDERS_SUCCESS) {
    return providers.reduce(
      (acc, item) => ({
        ...acc,
        [item.id]: item,
      }),
      {}
    );
  }
  return state;
};

export default combineReducers({
  status: statusReducer,
  byId: byIdReducer,
});
